<div class="modal-header">
    <h4 class="modal-title">{{employeeSchedule.employee.fullName}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">

    <div class="row" >
        <div class="col">{{'WorkShiftOf' | translate:{refDate: employeeSchedule.refDate | myDateFormat:'LL' }  }} </div>
    </div>
    <div class="row" >
        <div class="col">{{'WorkShift'|translate}} <b>{{employeeSchedule.startHour | myDateFormat:'LT' }} - {{employeeSchedule.endHour | myDateFormat:'LT' }}</b> </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="form-check">
                <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="employeeSchedule.active" > &nbsp;{{'ScheduleIsPublished' | translate}}
                </label>
            </div>
        </div>
    </div>

    <div style="margin-top:5px;">&nbsp;</div>

    <div class="row">
        <div class="col">
            <div class="form-group">
                <label> {{'Lunch' | translate}}&nbsp;
                    <ng-template [ngIf]="lunchVisible">
            <span (click)="lunchVisible=false">
              <i class="fad fa-caret-square-down" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                    <ng-template [ngIf]="!lunchVisible">
            <span (click)="lunchVisible=true">
              <i class="fad fa-caret-square-right" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                </label>
                <ng-template [ngIf]="lunchVisible">
                    <div class="container contour">
                        <div class ="row">
                            <div class="col">
                                <label>{{'LunchStartEndTime' | translate}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <input type="text" name="startEndLunchTime" class="form-control" validateStartEndTimeInterval [textMask]="{mask: maskStartEndTime}"  [(ngModel)] = "startEndLunchTimeStr" >
                            </div>
                            <div class="col">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input class="form-check-input" type="checkbox" [(ngModel)]="paidLunch" id="paidLunch"> &nbsp;{{'LunchIsPaid' | translate}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="form-group">
                <label> {{'Supper' | translate}}&nbsp;
                    <ng-template [ngIf]="supperVisible">
            <span (click)="supperVisible=false">
              <i class="fad fa-caret-square-down" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                    <ng-template [ngIf]="!supperVisible">
            <span (click)="supperVisible=true">
              <i class="fad fa-caret-square-right" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                </label>
                <ng-template [ngIf]="supperVisible">
                    <div class="container contour">
                        <div class ="row">
                            <div class="col">
                                <label>{{'SupperStartEndTime' | translate}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <input type="text" name="startEndSupperTime" class="form-control" validateStartEndTimeInterval [textMask]="{mask: maskStartEndTime}"  [(ngModel)] = "startEndSupperTimeStr" >
                            </div>
                            <div class="col">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input class="form-check-input" type="checkbox" [(ngModel)]="paidSupper" id="paidSupper"> &nbsp;{{'SupperIsPaid' | translate}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="form-group">
                <label for="break1">{{'Break1' | translate}}
                    <ng-template [ngIf]="break1Visible">
            <span (click)="break1Visible=false">
              <i class="fad fa-caret-square-down" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                    <ng-template [ngIf]="!break1Visible">
            <span (click)="break1Visible=true">
              <i class="fad fa-caret-square-right" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                </label>
                <ng-template [ngIf]="break1Visible">
                    <div class="container contour">
                        <div class="row">
                            <div class="col">
                                <ngb-timepicker [spinners]="spinners" [meridian]="meridian" [(ngModel)]="break1Date" id="break1"></ngb-timepicker>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="form-group">
                <label for="break1">{{'Break2' | translate}}
                    <ng-template [ngIf]="break2Visible">
            <span (click)="break2Visible=false">
              <i class="fad fa-caret-square-down" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                    <ng-template [ngIf]="!break2Visible">
            <span (click)="break2Visible=true">
              <i class="fad fa-caret-square-right" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                </label>
                <ng-template [ngIf]="break2Visible">
                    <div class="container contour">
                        <div class="row">
                            <div class="col">
                                <ngb-timepicker [spinners]="spinners" [meridian]="meridian" [(ngModel)]="break2Date" id="break2"></ngb-timepicker>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="form-control" >
                <label >{{'Note' | translate}}</label>
                <div class="mb-2 mr-sm-2 mb-sm-0">
                    <textarea class="form-control" name="Text1" [(ngModel)]="note" rows="5"></textarea>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="form-group">
                <label>{{'TasksAndFunction' | translate}}
                    <ng-template [ngIf]="tasksVisible">
            <span (click)="tasksVisible=false">
              <i class="fad fa-caret-square-down" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                    <ng-template [ngIf]="!tasksVisible">
            <span (click)="tasksVisible=true">
              <i class="fad fa-caret-square-right" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i>
            </span>
                    </ng-template>
                </label>
                <ng-template [ngIf]="tasksVisible">
                    <div class="container contour">
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Function' | translate}}</label>
                                    <input type="text" name="functionStr" maxlength="30" class="form-control" [(ngModel)]="functionStr">
                                </div>
                            </div>
                        </div>

                        <ng-template #ExplainBolt >
                            <div style="width:200px;">{{'FormatTaskToDisplayInDailyReport' | translate}}</div>
                        </ng-template>

                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task1' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(0)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task1"  maxlength="100" class="form-control" [(ngModel)]="task1" [textMask]="taskMask[0]" [placeholder]="placeholder[0]">
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task2' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(1)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task2"  maxlength="100"  class="form-control" [(ngModel)]="task2" [textMask]="taskMask[1]" [placeholder]="placeholder[1]">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task3' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(2)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task3"  maxlength="100"  class="form-control" [(ngModel)]="task3" [textMask]="taskMask[2]" [placeholder]="placeholder[2]">
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task4' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(3)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task4"  maxlength="100"  class="form-control" [(ngModel)]="task4" [textMask]="taskMask[3]" [placeholder]="placeholder[3]">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task5' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(4)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task5"  maxlength="100"  class="form-control" [(ngModel)]="task5" [textMask]="taskMask[4]" [placeholder]="placeholder[4]">
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task6' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(5)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task6"  maxlength="100"  class="form-control" [(ngModel)]="task6" [textMask]="taskMask[5]" [placeholder]="placeholder[5]">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task7' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(6)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task7"  maxlength="100"  class="form-control" [(ngModel)]="task7" [textMask]="taskMask[6]" [placeholder]="placeholder[6]">
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task8' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(7)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task8"  maxlength="100"  class="form-control" [(ngModel)]="task8" [textMask]="taskMask[7]" [placeholder]="placeholder[7]">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task9' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(8)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task9"  maxlength="100"  class="form-control" [(ngModel)]="task9" [textMask]="taskMask[8]" [placeholder]="placeholder[8]">
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>{{'Task10' | translate}}</label>&nbsp;<span class="naked emprez-bleu-cosmos" style="float:right" (click)="toggleMask(9)" placement="top" [ngbPopover]='ExplainBolt' triggers="mouseenter:mouseleave"><i class="fa fa-bolt"></i></span>
                                    <input type="text" name="task10"  maxlength="100"  class="form-control" [(ngModel)]="task10" [textMask]="taskMask[9]" [placeholder]="placeholder[9]">
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

</div>

<div class="modal-footer">
    <alert></alert>
    <button type="button" class="btn btn-primary" (click)="onValidate()">{{'Validate' | translate}}</button>
    <button type="button" class="btn btn-secondary" (click)="onCancel()">{{'Cancel' | translate}}</button>
</div>